import axios from 'axios';
import { FormEvent, useState } from 'react';
import { useConfig } from '../../config';
import { useTranslation } from '../../i18n/i18n';
import { Res, useCms } from '../../state/api';
import { ApiActionResponse } from '../../types';
import { AlertMessages, useAlerts } from '../AlertMessages/AlertMessages';
import { ContentCard } from '../ContentCard/ContentCard';
import { Button } from '../Form/Button';
import { TextInput } from '../Form/TextInput';
import { Main } from '../Main/Main';
import { Routing } from '../Routes';
import { CmsComponent } from '../cms/CmsComponent';

export const ForgotPasswordPage = (): JSX.Element => {
	const { api } = useConfig();
	const t = useTranslation().resetPassword;
	const tForm = useTranslation().form;
	const [email, setEmail] = useState('');
	const [successMsg, setSuccessMsg] = useState(false);
	const alerts = useAlerts();
	const { data: emailSent } = useCms(Res.cmsComponent, { slug: 'forgot-password-email-sent' });

	const handleFormSubmit = async (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		const payload = {
			email: email,
		};
		const res = await axios.post<ApiActionResponse>(`${api}forgot-password.json`, payload);
		if (res.data.errors) {
			alerts.set({ type: 'error', message: res.data.errors.join(' ') });
		} else if (res.data.success) {
			setSuccessMsg(true);
		} else {
			alerts.set({ type: 'error', message: t.unexpectedError });
		}
	};

	return (
		<Main>
			{successMsg ? (
				<CmsComponent structure={emailSent} />
			) : (
				<>
					<h1>{t.forgotPassword}</h1>
					<ContentCard>
						<AlertMessages alerts={alerts} />
						<form onSubmit={handleFormSubmit}>
							<TextInput
								type="email"
								id="forgot-password-email"
								placeholder={tForm.email}
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								autocomplete="email"
								autoFocus={true}
							/>
							<br />
							<Button>{t.send}</Button>
						</form>
					</ContentCard>
				</>
			)}
		</Main>
	);
};

export const forgotPasswordRouting: Routing = {
	path(urls) {
		return urls.resetPassword;
	},
	component: ForgotPasswordPage,
	requiresAuth: false,
};
